export default __webpack_public_path__ + "static/media/imagem_erp.436836f2.png";